import Constant from '@/const';
import axios from 'axios';

const postLabResult = async (idLab, payload) => {
  try {
    const response = await axios.post(
      Constant.apiUrl.concat(`/supportservice/laboratory/result/${idLab}`),
      payload,
    );
    return response;
  } catch (error) {
    this.showErrorAxios(error);
  }
};

export default postLabResult;
